import { FormattedMessage } from 'react-intl';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { Text } from 'ui-components/components/text/text';
import { TextType } from 'ui-components/components/text/text-type';

import { messages } from '../../../messages';

import type { PickListGridItem } from '../pick-list-grid';

type NameCellProps = {
  row: { original: PickListGridItem };
};

const NameCell = ({ row }: NameCellProps) => <Text shouldTruncate textType={TextType.Paragraph} value={row.original.name ?? ''} />;

export const createNameColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'name',
  Header: <FormattedMessage {...messages.gridColName} />,
  Cell: NameCell,
  width: 2.5,
});
